export const listCustomFiltersQuery = `
    query listCustomFiltersQuery($committeeId: String!) {
        getAthenaCustomFilters(committeeId: $committeeId) {
            filtersAsJson
            status
            error
        }
    }
`;